import { render, staticRenderFns } from "./EventTabVoters.vue?vue&type=template&id=c46b50e6&scoped=true&"
import script from "./EventTabVoters.vue?vue&type=script&lang=js&"
export * from "./EventTabVoters.vue?vue&type=script&lang=js&"
import style0 from "./EventTabVoters.vue?vue&type=style&index=0&id=c46b50e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46b50e6",
  null
  
)

export default component.exports